
import React, { Component } from 'react';
import Highcharts from 'highcharts'

class Chart1 extends Component {
    constructor() {
        super();
    }
    componentDidMount() {
        var colors = ['#00bcd4', '#E82C0C', '#acacac'];
        Highcharts.chart('chart_1_1', {
            chart: {
                type: 'column'
            },
            colors: colors,
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [
                    'Quarter ' + this.props.quarter + ' / FY21'
                ],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Number of entries'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.0f}</b> people</td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                name: 'Total list',
                data: [this.props.max_in_quarter],
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }
            }, {
                name: 'Online invitation sent',
                data: [this.props.total_invitation_sent],
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }

            }, {
                name: 'Online survey complete',
                data: [this.props.total_online_success],
                color: "#8bc34a",
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }
            },
            {
                name: 'Tele complete',
                data: [this.props.total_tele_success],
                color: "#33994a",
                dataLabels: {
                    enabled: true,
                    verticalAlign: 'bottom',
                    overflow: 'none',
                    crop: false,
                    //y: 20,
                    formatter() {
                        return this.point.y;
                    }
                }
            }]
        });
    }
    render() {
        return (
            <div className={"chart-box"}>
                <center>
                    <div id="chart_1_1" style={{ width: "92%", height: "450px" }}></div>
                </center>
            </div>
        );
    }
}

export default Chart1;